import { FC } from 'react';

import Modal, { ModalProps } from 'antd/lib/modal/Modal';
import SubmitButton from 'components/buttons/SubmitButton/SubmitButton';
import BenefitCarrier from 'model/BenefitCarrier';
import closeIcon from 'images/icon-close.svg';
import { addHttp } from 'utils/httpUtil';
import { useAppSelector } from 'hooks/redux';
import { getText } from 'utils/stringUtil';
import {
  PROVIDER_SEARCH,
  SEARCH_INSTRUCTIONS,
  NETWORK_NAME_FOR_PLAN,
  SEARCH_PROVIDERS_ON_WEBSITE,
  ADDITIONAL_INFORMATION,
  SEARCH_ON_CARRIER_SITE,
} from 'constants/languageConstants';

import styles from './providerSearchModal.module.less';

interface ProviderSearchModalProps extends ModalProps {
  visible: boolean;
  carrier: BenefitCarrier;
  planName: string;
  networkName: string;
}

const ProviderSearchModal: FC<ProviderSearchModalProps> = ({
  onCancel,
  visible,
  carrier,
  planName,
  networkName,
}: ProviderSearchModalProps) => {
  const { name, logoUrl, providerSearchUrl, providerSearchAdditionalInfo } =
    carrier || {};
  const language = useAppSelector((state) => state.benguide.data?.language);

  const searchCarrier = () => {
    providerSearchUrl && window.open(addHttp(providerSearchUrl), '_blank');
  };

  return (
    <Modal
      maskClosable={false}
      width={820}
      visible={visible}
      footer={null}
      centered
      className={styles.providerSearchWrapper}
      onCancel={onCancel}
      closeIcon={<img src={closeIcon} alt="close-icon" />}
    >
      <div className={styles.providerHeader}>
        {getText(PROVIDER_SEARCH, language)}
      </div>
      <div className={styles.logoWrapper}>
        <img src={logoUrl} alt="carrier" className={styles.logo} />
      </div>
      <div className={styles.instructionWrapper}>
        <div className={styles.searchHeader}>
          {getText(SEARCH_INSTRUCTIONS, language)}
        </div>
        {networkName && (
          <>
            <span className={styles.urlSection}>
              {getText(NETWORK_NAME_FOR_PLAN, language)}{' '}
              <p className={styles.boldTextWrapper}>({planName})</p>{' '}
              {language === 'SPANISH' ? 'es' : 'is'}{' '}
              <p className={styles.boldTextWrapper}>{networkName}</p>
            </span>
            <div className={styles.urlSectionSeparator} />
          </>
        )}
        <span>
          {getText(SEARCH_PROVIDERS_ON_WEBSITE, language)} {name}
          {language === 'SPANISH' ? ' en' : "'s website at"}
          <a
            className={styles.homeUrl}
            href={addHttp(providerSearchUrl ? providerSearchUrl : '')}
            target="_blank"
            rel="noreferrer"
          >
            {providerSearchUrl}
          </a>
        </span>
      </div>
      {providerSearchAdditionalInfo && (
        <div className={styles.additionalInfo}>
          <div className={styles.searchHeader}>
            {getText(ADDITIONAL_INFORMATION, language)}
          </div>
          <ul className={styles.instructionList}>
            {providerSearchAdditionalInfo}
          </ul>
        </div>
      )}

      <div className={styles.buttonWrapper}>
        <SubmitButton
          className={styles.searchButton}
          onClick={searchCarrier}
          type="primary"
        >
          {getText(SEARCH_ON_CARRIER_SITE, language)}
        </SubmitButton>
      </div>
    </Modal>
  );
};

export default ProviderSearchModal;
